import type { ReactNode } from 'react';

import type { LessonAssessmentType } from 'modules/classes/core/enum';

import type { FunctionalTestMethod, FunctionalTestType } from './enum';

export interface Exercises {
  id: string;
  name: string;
  reps: number;
  sets: number;
  duration: number;
  category: Config;
  description: string;
  created_at: string;
  lessonExerciseId?: string;
  restTime: number;
  index: number;
  thumbnail?: string;
  video?: string;
  functionalTest?: FunctionalTest;
  level?: number;
  upperBody?: number;
  lowerBody?: number;
  lessonLevel: number;
  videoHeight?: number;
  videoWidth?: number;
}

export interface DropDownLabelProps {
  title: string;
  icon: ReactNode;
}

export interface Config {
  id: number;
  name: string;
  key: string;
  type: string;
}

export enum LessonType {
  TODAY = 'today',
  UP_COMMING = 'upcoming',
  TO_BE_SCHEDULED = 'to be scheduled',
  PAST = 'past',
}

export interface Lessons {
  id: string;
  name: string;
  exercises: Exercises[];
  type: Config;
  totalExercises: number;
  thumbnail?: string;
  created_at?: string;
  courseLessonId?: string;
  classLessonId?: string;
  start?: string;
  end?: string;
  originStart?: string;
  originEnd?: string;
  totalCompleted?: number;
  classScheduleId?: string;
  index?: number;
  lessonType?: LessonAssessmentType;
  totalAssessments?: number;
  completedOn?: string;
  action?: number;
}

export interface Courses {
  id: string;
  name: string;
  totalLessons: number;
  lessons: Lessons[];
  assessments: Assessment[];
  totalAssessments: number;
  thumbnail?: string;
}

export interface FunctionalTest {
  id: string;
  name: string;
  maxScore: string;
  type: FunctionalTestType;
  thresholdTime: number;
  protocol: string;
  video: string;
  thumbnail: string;
  scoreRules: ScoringRuleItem[];
  method: FunctionalTestMethod;
  assessmentFunctionalTestId?: string;
  isSO2AndHR?: boolean;
  isAddition?: boolean;
}

export interface ScoringRuleItem {
  id: string;
  min: number;
  max: number;
  score: number;
  parentId: string;
}

export interface Assessment {
  id: string;
  name: string;
  totalFunctionalTests: number;
  functionalTests: FunctionalTest[];
  courseAssessmentId?: string;
  isClass: boolean;
  isOnboarding: boolean;
  isDefault: boolean;
  completedOn?: string;
  start?: string;
  end?: string;
  assessmentScore?: number;
  maxScore?: number;
}

export interface SelectMetricLabelProps {
  title: ReactNode;
  description?: ReactNode;
}
